export default __webpack_public_path__ + "static/media/etherscan.ed05e6f9.png";